module.exports = __webpack_public_path__ + "static/media/logo-internal-retina.b362008a.png";